export default __webpack_public_path__ + "static/media/co2.0c0012dc.svg";